import styled from "styled-components";
import tickIcon from "@/assets/tickIcon.png";
import { media } from "@/theme/breakpoints";

export const MainContainer = styled.div`
  overflow-x: hidden;
`;

export const InnerContainer = styled.div`
  display: flex;
  gap: 2%;
  justify-content: center;
  align-items: baseline;
  flex-wrap: wrap;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;

  ${media.downTablet`
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    padding: 0;
    width: 100%;
  `}
`;

export const CardsWrapper = styled.div`
  width: 30%;
  border-radius: 8px;
  border: 1px solid #dae0e7;
  background: #fafafa;
  padding: 20px;
  box-sizing: border-box;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;

  ${media.downTablet`
    width: 100%;
    margin-top: 24px;

    &:first-child {
      margin-top: 0;
    }
  `}
`;

export const ProCardWrapper = styled.div`
  width: 30%;
  border-radius: 8px;
  border: 1px solid #dae0e7;
  background: #fafafa;
  padding: 20px;
  border-top: 25px solid #ed6928;
  border-bottom: 4px solid #ed6928;
  box-sizing: border-box;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;

  ${media.downTablet`
    width: 100%;
    margin-top: 24px;
  `}
`;

export const StyledHeading = styled.h3`
  margin: 0;
  color: #171725;
  font-family: Poppins;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const StyledSubHeading = styled.p`
  margin: 0;
  color: #585858;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-top: 20px;
`;

export const StyledSubHeadingEnterprise = styled.p`
  margin: 0;
  color: #585858;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-top: 20px;
  visibility: hidden;
`;

export const InnerWrapper = styled.div`
  text-align: center;
  margin-bottom: 30px;
  max-width: 100%;
  min-width: 0;
`;

export const ButtonWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

export const StyledButton = styled.a`
  color: #fafafb;
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  border-radius: 5px;
  border: 0px solid #94e3d0;
  background: #ed6928;
  padding: 10px 24px;
  min-height: 44px;
  width: 170px;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0 auto;

  ${media.downTablet`
    width: 100%;
    max-width: 100%;
    padding: 12px 16px;
  `}
`;

export const StyledCancelButton = styled.button`
  display: block;
  width: max-content;
  margin: 8px auto 0;
  padding: 6px 12px;
  font-family: Poppins;
  font-size: 11px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.02em;
  color: #94a3b8;
  background: transparent;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s, border-color 0.2s, background 0.2s;
  &:hover {
    color: #b91c1c;
    border-color: #fca5a5;
    background: #fef2f2;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const StyledButtonEnterprise = styled.a`
  color: #fafafb;
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  border-radius: 5px;
  border: 0px solid #94e3d0;
  background: #000;
  padding: 10px 24px;
  min-height: 44px;
  width: 170px;
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0 auto;

  ${media.downTablet`
    width: 100%;
    max-width: 100%;
    padding: 12px 16px;
  `}
`;

export const StyledPrice = styled.span`
  color: #171725;
  font-family: Montserrat;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.2px;
`;

export const StyledCategory = styled.span`
  color: #171725;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.2px;
`;

export const PriceMetaRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 6px;
  max-width: 100%;
`;

export const PriceLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
  max-width: 100%;
`;

export const OriginalYearlyPrice = styled.span`
  color: #8b8b8b;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  text-decoration: line-through;
`;

export const DiscountBadge = styled.span`
  background: rgba(237, 105, 40, 0.12);
  color: #ed6928;
  border: 1px solid rgba(237, 105, 40, 0.35);
  border-radius: 999px;
  font-family: Poppins;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
`;

export const StyledFeaturedHeading = styled.span`
  color: #ed6928;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const StyledUl = styled.ul`
  padding-left: 0px;
`;

export const StyledLi = styled.li`
  color: var(--black, #334155);
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.1px;
  background: url(${tickIcon}) no-repeat left center;
  list-style: none;
  padding-left: 20px;
  padding-bottom: 7px;
  padding-top: 7px;
`;
